import React from 'react';
import { ModularSubscriptionsElements } from '../../../../context/SubscriptionsHandlerProvider/types';
import { useViewModel } from './viewModel/index.web';

export const StripePaymentHistory: ModularSubscriptionsElements['PaymentHistoryScreen'] = {
    Main: () => {
        useViewModel();
        return <></>;
    },
    View: () => <></>,
};
